import { Layout, Button } from "antd";
import { Outlet, useNavigate } from "react-router-dom";

const { Header, Content } = Layout;

export default function PublicLayout() {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/*  Top Header */}
      <Header
        style={{
          background: "var(--color-bg-card)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 var(--spacing-lg)",
          borderBottom: "1px solid var(--color-border-subtle)",
        }}
      >
        {/* Brand / Title */}
        <div style={{ fontWeight: 600, fontSize: "var(--font-size-base)" }}>
          Ezygo Admin
        </div>

        {/* Actions */}
        <div>
          <Button
            type="link"
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </Button>

          <Button
            type="primary"
            onClick={() => navigate("/login")}
          >
            Admin Login
          </Button>
        </div>
      </Header>

      {/* Page Content */}
      <Content style={{ background: "var(--color-bg-page)" }}>
        <Outlet />
      </Content>
    </Layout>
  );
}
